import { createReducer } from "./functions";

import {
  LOG_SET_CURRENT_FILTERS,
  LOG_SET_PAGINATION,
  LOG_SET_FILTERS,
  LOG_SET_LOGS,
  LOG_SET_SORT,
  LOG_SET_KEY_FILTER_SELECTED,
  LOG_ADD_CURRENT_FILTERS
} from "../types";

const initialState = {
  logs: [],
  page: 0,
  pages: 0,
  pageSize: 10,
  hasNext: true,
  filters: null,
  currentFilters: {},
  sort: { startDate: -1 },
  keyFilterSelected: null
};

const setFilters = {
  [LOG_SET_FILTERS]: (state, action) => {
    let newFilters = { ...state.filters };
    newFilters[action.key] = action.values;
    return { ...state, filters: newFilters };
  }
};

const setLogs = {
  [LOG_SET_LOGS]: (state, action) => {
    const page = action.payload.hasOwnProperty("page") ? action.payload.page : state.page;
    const pages = action.payload.hasOwnProperty("pages") ? action.payload.pages : state.pages;

    let hasNext = true;
    if (page === 0 || page === pages) {
      hasNext = false;
    }
    return { ...state, logs: action.payload.docs, page, pages, hasNext };
  }
};

const setCurrentFilters = {
  [LOG_SET_CURRENT_FILTERS]: (state, action) => {
    const currentFilters = { ...action.currentFilters };
    if (action.currentFilters.hasOwnProperty("period")) {
      currentFilters.startDate = {
        $gte: { $date: action.currentFilters.period.startDate }
      };
      currentFilters.endDate = {
        $lte: { $date: action.currentFilters.period.endDate }
      };
      delete currentFilters["period"];
    }

    return Object.assign({}, state, {
      currentFilters: currentFilters
    });
  }
};

const setSort = {
  [LOG_SET_SORT]: (state, action) => {
    return {
      ...state,
      sort: { [action.column]: action.sortOrder }
    };
  }
};
const setPagination = {
  [LOG_SET_PAGINATION]: (state, action) => {
    return Object.assign({}, state, { page: action.page, pages: action.pages });
  }
};

const setKeyFilterSelected = {
  [LOG_SET_KEY_FILTER_SELECTED]: (state, action) => {
    return { ...state, keyFilterSelected: action.key };
  }
};

const addCurrentFilter = {
  [LOG_ADD_CURRENT_FILTERS]: (state, action) => {
    const currentFilters = state.currentFilters || {};
    currentFilters[action.key] = action.filters;
    return Object.assign({}, state, { currentFilters: currentFilters });
  }
};

const logReducer = createReducer(initialState, {
  ...setCurrentFilters,
  ...addCurrentFilter,
  ...setPagination,
  ...setFilters,
  ...setLogs,
  ...setSort,
  ...setKeyFilterSelected
});

export default logReducer;



// WEBPACK FOOTER //
// src/redux/reducers/logReducer.js